import { Address } from "./address";
import { Asset } from "./asset";
import { Network } from "./network";
import { Signer } from "./signer";

export interface AccountProvider<P> {
  /** undefined until loaded. null if loaded and not present */
  accounts: { address: Address; provider: P }[] | undefined | null;
  selected?: { address: Address; provider: P };
  signer: (address: Address) => Signer;
  select: (account?: { address: Address; provider: P } | null) => void;
  connect: (provider: P) => ConnectionResponse;
  disconnect: (provider: P) => void;
  disconnectAll: () => void;
  isAvaialable: (provider: P) => boolean;
  isLoading?: boolean;
}

export const isThor = (a: Address): boolean =>
  a.startsWith("thor") || a.startsWith("sthor") || a.startsWith("tthor");

export interface Account {
  address: Address;
  network: Network;
}

export interface BalanceAccount {
  address: Address;
  balance: bigint;
  asset: Asset;
  valueUsd: bigint;
}

export type Balance = {
  asset: Asset;
  balance: bigint;
  accounts: ReadonlyArray<BalanceAccount>;
  valueUsd: bigint;
};

export type Balances = Balance[];

export type ConnectionResponse = Promise<void>;

export interface InboundAddress {
  address: string;
  dustThreshold: bigint;
  router?: string;
  gasRate: bigint;
}
